var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"furn-media"},[_c('gallery'),_c('div',{staticClass:"min-u animation",staticStyle:{"max-width":"350px"}},[_c('media-and-photograph')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }